import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, Download, CheckCircle2 } from "lucide-react";

const trustBadges = [
  "SAICA Registered",
  "SARS Compliance Support",
  "CIPC Annual Returns",
  "Payroll & UIF",
];

export function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-background min-h-[calc(100svh-5rem)] flex items-start">
      <svg
        className="absolute inset-x-0 top-0 h-40 md:h-56 w-full pointer-events-none opacity-70"
        viewBox="0 0 1440 220"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {Array.from({ length: 9 }).map((_, index) => (
          <path
            key={index}
            d={`M-60 ${24 + index * 14} C 170 ${-15 + index * 9}, 290 ${110 + index * 4}, 490 ${65 + index * 5} S 710 ${25 + index * 8}, 910 ${88 + index * 3} S 1180 ${88 - index * 2}, 1510 ${34 + index * 8}`}
            fill="none"
            stroke="hsl(var(--primary) / 0.10)"
            strokeWidth={index === 2 ? 1.4 : 0.8}
          />
        ))}
      </svg>

      <div className="absolute -right-28 top-0 h-96 w-80 md:h-[32rem] md:w-[26rem] rounded-bl-[12rem] bg-accent/70 rotate-45 pointer-events-none" />
      <div className="absolute -right-20 bottom-20 h-72 w-96 rounded-tl-[10rem] bg-accent/60 -rotate-12 pointer-events-none" />
      <div className="absolute -left-32 -bottom-32 h-72 w-96 rounded-tr-[10rem] bg-accent/55 rotate-12 pointer-events-none" />
      <svg
        className="absolute bottom-0 right-10 hidden md:block h-48 w-[42rem] pointer-events-none opacity-60"
        viewBox="0 0 680 190"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {Array.from({ length: 10 }).map((_, index) => (
          <path
            key={index}
            d={`M0 ${96 + index * 6} C 110 ${130 - index * 8}, 210 ${132 - index * 10}, 320 ${144 - index * 6} S 500 ${148 - index * 4}, 700 ${86 + index * 3}`}
            fill="none"
            stroke="hsl(var(--primary) / 0.12)"
            strokeWidth="0.8"
          />
        ))}
      </svg>

      <div className="container mx-auto px-4 pt-28 md:pt-32 lg:pt-36 pb-16 relative z-10">
        <div className="mx-auto max-w-5xl text-center">
          <div className="inline-flex items-center gap-2 bg-muted rounded-full px-4 py-2 mb-7 animate-fade-up shadow-sm">
            <span className="w-2 h-2 rounded-full bg-primary" />
            <span className="text-sm font-medium text-foreground">
              Trusted by South African Businesses
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-[4.25rem] font-bold text-gradient mb-7 animate-fade-up stagger-1 leading-none tracking-normal">
            Bookkeeping Services for
            <br />
            South African Businesses
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground mb-10 animate-fade-up stagger-2 leading-relaxed max-w-2xl mx-auto">
            From monthly bookkeeping and VAT, payroll to annual financial statements,
            income tax and CIPC compliance — we handle your financial admin so you
            can focus on growing your business.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-14 animate-fade-up stagger-3">
            <Link to="/book-a-call" className="sm:inline-flex">
              <Button size="lg" className="btn-primary gap-2 text-base px-8 h-14 w-full sm:w-auto">
                <Phone className="w-5 h-5" />
                Book a Call
              </Button>
            </Link>
            <a href="/BOOKKEEPING_SERVICES_SA_packages.pdf" download className="sm:inline-flex">
              <Button size="lg" variant="outline" className="btn-secondary gap-2 text-base px-8 h-14 w-full sm:w-auto bg-background">
                View Packages
                <Download className="w-5 h-5" />
              </Button>
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-3 animate-fade-up stagger-4">
            {trustBadges.map((badge) => (
              <div key={badge} className="trust-badge text-sm shadow-sm">
                <CheckCircle2 className="w-4 h-4 text-primary" />
                {badge}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
